// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2ufq0","content":"RecentSearches_content__39vvm"};